module.exports = __webpack_public_path__ + "img/14Campaign_Information.37199ffa.png";